const ScrollableContainer = ({ children, maxHeight }) => {
  return (
    <div
      style={{
        ...(maxHeight && { maxHeight }),
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        flexShrink: 1,
        minHeight: 0,
        height: 0, // Required for overflow to work in flex containers
      }}
    >
      {children}
    </div>
  );
};

export default ScrollableContainer;
